<template>

	<div :class="{'hide': loading}">
		<div v-if="loading" :class="{'spinner loading': loading}"></div>


		<div class="product-list grid reviews column3-wrap slider">


			<agile v-if="reviews.length" :options="agileOptions">
				<div v-for="review in reviews" :key="review.id">
					<div class="product-item column slide">
					<!-- PRODUCT PREVIEW ACTIONS -->
					<div class="product-info">
						<p class="title text-header">{{review.order.quantity}} pages, {{review.order.discipline_name}} ({{review.order.id}}**)</p>
						<p class="category tiny primary">{{review.created_at | fromNowAgo}}</p>
						<p class="time"></p>
						<p class="price big"><span>$</span>{{priceCalculation(review.order.deadline, review.order.quality) * review.order.quantity}}</p>
						<!--<p class="price big"><span>$</span>{{review.order.price}}</p>-->
					</div>

					<div class="comment">

						<p>"{{review.body}}"</p>
						<!-- /PRODUCT PREVIEW IMAGE -->
					</div>


					<div class="user-rating">
						<div class="mark">
							<star-rating :rating="review.commentable.mark ? review.commentable.mark : 10" :round-start-rating="false" :star-size="12" :read-only="true" :inline="true"></star-rating>
						</div>
					</div>
					<!-- /PRODUCT PREVIEW ACTIONS -->

					<!-- PRODUCT INFO -->
					<!-- /PRODUCT INFO -->

					<hr class="line-separator">

					<!-- USER RATING -->
					<div class="user-rating">
						<a href="/writers">
							<figure class="user-avatar small">
								<img :src="'images/avatars/'+review.writer_of_order.avatar" alt="user-avatar">
							</figure>
						</a>
						<a :href="'/writers/'+review.writer_of_order.name">
							<p class="text-header tiny">Writer: <span>{{review.writer_of_order.name}}</span></p>
						</a>
					</div>
					<!-- /USER RATING -->
					</div>
				</div>
				<template slot="prevButton"><i  class="fas fa-chevron-left" ></i></template>
				<template slot="nextButton"><i class="fas fa-chevron-right"></i></template>
			</agile>

		</div>

	</div>
</template>


<script>
    import pricingMixin from '../../../Mixins/pricingMixin.js';

    export default {
        props: ['writer'],
        mixins: [pricingMixin],


        data() {
            return {
                dataSet: false,
                reviews: false,
                loading: true,


                asNavFor1: [],
                asNavFor2: [],
                options1: {
                    dots: false,
                    fade: true,
                    navButtons: false
                },

                agileOptions: {
        			infinite: true,
					autoplaySpeed: 5000,
					slidesToShow: 1,
                    autoplay: true,
                    centerMode: true,
                    dots: false,
                    navButtons: false,
                    responsive: [
                        {
                            breakpoint: 935,
                            settings: {
                                slidesToShow: 2,

                            }
                        },

                        {
                            breakpoint: 1260,
                            settings: {
                                slidesToShow: 3,
                            }
                        }
                    ]

                },


            }
        },

        created(){
            this.fetch();
        },


        watch: {

        },


        methods: {

            fetch() {
                this.loading = true;
                axios.get(this.url()).then(this.refresh);
            },

            url() {

                return '/api/feedbacks?include=order&append=writer_of_order&filter[in_orders_where_min_mark]=8&include=commentable&count=9';

            },

            refresh({data}) {
                this.dataSet = data;
                this.reviews = data.data;
                this.loading = false;
            },



        },
    }
</script>